

import { useParams } from "react-router-dom";
import { LayoutItemDeOp, LayoutTabla } from "../../layouts";
import { useTrazabilidadXItem } from "../../../hooks/cache";
import { CargandoMedio, MensajeAlertaDanger } from "../../components";
import { Pagination, Stack, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import { fechaConHora } from "../../../helpers/prepararFecha";


const paginado = Number(process.env.REACT_APP_PAGINADO);


export const RegistroColaborador = () => {


    const { id } = useParams(); 
    const { data, isLoading } = useTrazabilidadXItem(id);

    
    return (

        <LayoutItemDeOp titulo='Trazabilidad de Item' add={false}>
            {(isLoading)
            ?   <CargandoMedio titulo="Cargando información de trazabilidad por item..." />
            :   <>
                {(data?.length > 0)
                ?   <LayoutTabla
                        paginado={
                        <Stack sx={{ py:2, display:'flex', justifyContent:'center', alignItems:'center' }}>
                            <Pagination count={Math.ceil(50 / +paginado)} disabled={Math.ceil(50 / +paginado) === 1}
                                variant="outlined" page={0 + 1} color="primary" 
                                onChange={ null } 
                            />
                        </Stack>
                    }>
                        <TableHead>
                            <TableRow>
                                <TableCell sx={{width:'20%'}}>Fecha</TableCell>
                                <TableCell sx={{width:'25%'}}>Colaborador</TableCell>
                                <TableCell sx={{width:'15%'}}>Role</TableCell>
                                <TableCell sx={{width:'20%'}}>Antes</TableCell>
                                <TableCell sx={{width:'20%'}}>Ahora</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {data.map( item => (
                                <TableRow key={ item.id }>
                                    <TableCell>{ fechaConHora(item?.createdAt) }</TableCell>
                                    <TableCell>{ item.colaborador?.nombre }</TableCell>
                                    <TableCell>{  item.colaborador?.role }</TableCell>
                                    <TableCell>{ item.antes }</TableCell>
                                    <TableCell>{ item.ahora }</TableCell>
                                </TableRow>
                            ))
                            }
                        </TableBody>
                    </LayoutTabla>
        
                :   <MensajeAlertaDanger titulo='No hay registro de movimiento de este item...' />
                }
                </>
            }
        </LayoutItemDeOp>
    )
}
